import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import { translate } from 'components/Translation';
import React from 'react';
import ListOfComplaints from './ListOfComplaints';

const HistoryOfComplaints = () => {
	return (
		<>
			<BreadcrumbsItem to="/dashboard/history-of-complaints">
				{translate('path.history.of.complaints')}
			</BreadcrumbsItem>
			<ListOfComplaints />
		</>
	);
};

export default HistoryOfComplaints;
